import React from 'react';

interface ServerlessIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

export const ServerlessIcon: React.FC<ServerlessIconProps> = ({ size = 20, ...props }) => {
  return (
    <svg
      fill="none"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      height={size}
      width={size}
    >
      <path
        clipRule="evenodd"
        d="M6.014 9.262H4.092a.738.738 0 1 0 0 1.476h1.64c-.128.712-.236 1.39-.337 2.018l-.015.095c-.146.916-.274 1.707-.425 2.363-.154.669-.316 1.115-.492 1.383-.15.23-.258.26-.37.26a.949.949 0 0 1-.95-.95.738.738 0 0 0-1.477 0 2.426 2.426 0 0 0 2.426 2.426c.731 0 1.256-.392 1.607-.927.325-.497.533-1.158.695-1.86.165-.715.3-1.56.445-2.463l.014-.087c.113-.712.234-1.468.38-2.258h1.922a.738.738 0 0 0 0-1.476h-1.64c.129-.712.237-1.39.337-2.018l.015-.095c.146-.916.274-1.707.426-2.363.154-.669.316-1.115.491-1.383.15-.23.259-.26.371-.26a.95.95 0 0 1 .95.95.738.738 0 0 0 1.477 0 2.426 2.426 0 0 0-2.427-2.426c-.73 0-1.256.392-1.606.927-.326.497-.533 1.158-.695 1.86-.165.715-.301 1.56-.445 2.463l-.014.087a87.3 87.3 0 0 1-.38 2.258Zm5.995.216a.738.738 0 0 1 1.044 0l2.01 2.01 2.01-2.01a.738.738 0 1 1 1.043 1.044l-2.01 2.01 2.01 2.01a.738.738 0 1 1-1.044 1.043l-2.01-2.01-2.009 2.01a.738.738 0 0 1-1.044-1.044l2.01-2.01-2.01-2.009a.738.738 0 0 1 0-1.044Z"
        fill="#B5BCC4"
        fillRule="evenodd"
      />
    </svg>
  );
};
